/**
 * Create an HTML object based on parameters.
 *
 * @param    {string}   type        The type of HTML object to create
 * @param    {?object}  attributes  A list of key-value attributes to assign to the HTML object
 * @param    {?object}  style       A list of key-value styles to assign to the HTML object
 * @param    {?string}  text        The text to insert into the HTML object
 * @returns  {object}               The HTML object itself
 */
export function create(type, attributes, style, text)
{
	// Create the object
	var obj = document.createElement(type);

	// Set attributes, if there
	setAttributes(obj, attributes);

	// Set styles, if there
	setStyles(obj, style);

	// Set text or value (depending on type)
	if (text)
	{
		if (['input', 'button'].includes(type)) obj.value = text;
		else obj.innerText = text;
	}

	// Return
	return obj;
};

/**
 * Set attributes for an HTML object.
 *
 * @param    {object}   obj         The HTML object itself
 * @param    {?object}  attributes  A list of key-value attributes to assign to the HTML object
 * @returns  {void}
 */
export function setAttributes(obj, attributes)
{
	// Double check if object exists
	if (obj)
	{
		// Set attributes, if there
		if (!attributes) attributes = {};
		for (let key in attributes) obj.setAttribute(key, attributes[key]);
	}
}

/**
 * Set styles for an HTML object.
 *
 * @param    {object}   obj     The HTML object itself
 * @param    {?object}  styles  A list of key-value styles to assign to the HTML object
 * @returns  {void}
 */
export function setStyles(obj, styles)
{
	// Double check if object exists
	if (obj)
	{
		// Set styles, if there
		if (!styles) styles = {};
		for (let key in styles) obj.style[key] = styles[key];
	}
}

/**
 * Remove styles from an HTML object.
 *
 * @param    {object}  obj     The HTML object itself
 * @param    {?Array}  styles  An array of key styles to be removed from the HTML object
 * @returns  {void}
 */
export function removeStyles(obj, styles)
{
	// Double check if object exists
	if (obj)
	{
		// Remove styles, if there
		if (!styles) styles = [];
		for (let key of styles) obj.style.removeProperty(key);
	}
}